module.exports = __webpack_public_path__ + "img/scene_bedtime_tw_backlight@2x.ea3d6fc7.png";